import { useParams } from 'react-router-dom';

import { Offering } from '@arrived/models';
import { useOfferingQuery, UseQueryOptions } from '@arrived/queries';

/**
 * Fetches the offering associated with the id/short name in the URL.
 */
export const useOfferingFromUrlParams = (options?: UseQueryOptions<Offering>) => {
  const { idOrShortName } = useParams();

  return useOfferingQuery(idOrShortName!, {
    ...options,
    enabled: (options?.enabled ?? true) && Boolean(idOrShortName),
  });
};
